import { AUTH0_CONFIG } from "src/app/config/auth0-config";

/**
 * A app e servida pelo nginx no mesmo dominio que o /api/ (Flask) e o
 * /newapi/ (apiserver) - timing.geolink.pt em producao, timingdev.geolink.pt
 * em dev. Por isso os URLs saem do dominio em que a pagina foi aberta e o
 * mesmo ficheiro serve os dois servidores sem alteracoes locais.
 * Aberta em localhost (ng serve na maquina de desenvolvimento), usa o dev.
 */
const FALLBACK_ORIGIN = "https://timingdev.geolink.pt";

function serverOrigin(): string {
  if (typeof window === "undefined" || !window.location) return FALLBACK_ORIGIN;
  const origin = window.location.origin;
  if (/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/.test(origin)) return FALLBACK_ORIGIN;
  return origin;
}

const ORIGIN = serverOrigin();

export const environment = {
  production: false,
  auth: AUTH0_CONFIG,

  baseUrl: `${ORIGIN}/api/`,
  baseUrlNew: `${ORIGIN}/newapi/`,

  registerPortoCardUrl: "https://cartaoporto.services.dev.portodigital.pt/",
  sibsUrl: 'https://spg.qly.site1.sibs.pt/assets/js/widget.js?id='
};
